import React, { useEffect, useRef, useState } from 'react';
import { Title, TooltipCard, TooltipIcon } from './info-tool-tip.styles';

interface TooltipProps {
  title: string;
  body: React.ReactNode;
  offsetX: string;
  offsetY: string;
}

function InfoToolTip({
  title,
  body,
  offsetX = '0px',
  offsetY = '0px',
}: TooltipProps) {
  const [show, setShow] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const iconRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node) &&
        iconRef.current &&
        !iconRef.current.contains(event.target as Node)
      ) {
        setShow(false);
      }
    }

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const icon = show
    ? '/icons/roundQuestionMarkFilledBlue.png'
    : '/icons/roundQuestionMarkFilledBlack.png';
  return (
    <div>
      <TooltipIcon
        data-testid="tooltip-icon"
        src={icon}
        ref={iconRef}
        onClick={() => setShow(!show)}
      />

      <TooltipCard
        offsetX={offsetX}
        offsetY={offsetY}
        ref={tooltipRef}
        show={show}
      >
        <Title>{title}</Title>
        {body}
      </TooltipCard>
    </div>
  );
}

export default InfoToolTip;
